const features = {
  ai: 'AI',
  featureAiDescription: 'Turn every AI feature on or off.',
  featureGithubDescription: 'Monitor GitHub repositories.',
  featureKey: 'Key',
  featureObjectivesDescription: 'Track goals and their progress.',
  featureStravaDescription: 'Monitor Strava athletes.',
  featureSubstackDescription: 'Monitor Substack publications.',
  features: 'Features',
  featuresIntro: 'Choose which parts of the app are available to everyone.',
  featuresLoadFailed: 'Could not load features.',
  featureTasksDescription: 'Track work to get done.',
  featureTimesheetDescription: 'Record time spent during the day.',
  featureYoutubeDescription: 'Monitor YouTube channels.',
  featureUpdateFailed: 'Could not update features. Try again.',
};

export default features;
